import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { history } from 'store';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import MemberEdit from '../../memberMaintenance/memberEdit/index';
import {
    addFavouriteMember,
    onMemberSelect,
    onDeleteMember,
    onEditMember,
    selectMember,
} from 'actions/member';

const MemberRow = (props) => {
    const dispatch = useDispatch();
    const [menuState, setMenuState] = useState(false);
    const [member, setMember] = useState(props.member);
    const [deleteMemberCheck, setDeleteMemberCheck] = useState(false);
    const width = useSelector(state => state.settings.width);
    // const { member } = props;

    useEffect(() => {
        setMember(props.member);
    }, [props]);

    const { name, starred } = member;
    const options = [
        'Edit',
        'Delete',
    ];

    const memberOptionToggle = () => {
        setMenuState(!menuState);
    };

    const deleteMember = (member) => {
        dispatch(onDeleteMember(member?.id));
    };

    const editMember = () => {
        setMenuState(false);
        dispatch(onEditMember(member));
    };

    return (
        <div className="contact-item">
            <ListRowCheckbox selected={member.selected} onClick={() => dispatch(onMemberSelect(member))} />
            <ListRowFavourite width={width} onClick={() => dispatch(addFavouriteMember(member))} starred={starred} />
            <ListRowImage width={width} data={member} />
            <ListRowData lineOne={name} />
            <ListRowDropdown
                menuState={menuState}
                toggle={memberOptionToggle}
                options={options}
                dropdownItems={options.map(option =>
                    <DropdownItem key={option} onClick={() => {
                        if (option === 'Edit') {
                            editMember();
                        } else if (option === 'Delete') {
                            setDeleteMemberCheck(true);
                        }
                    }
                    }>
                        {option}
                    </DropdownItem>,
                )}
            />
            <div>
                <MemberEdit />
            </div>
            <SweetAlert show={deleteMemberCheck}
                warning
                showCancel
                confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                cancelBtnText={<IntlMessages id="button.cancel" />}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                onConfirm={() => {
                    deleteMember(member);
                    setDeleteMemberCheck(false);
                }}
                onCancel={() => {
                    setDeleteMemberCheck(false);
                }}
            >
                <IntlMessages id="member.deleteMember" />
            </SweetAlert>
        </div>
    );
};

export default MemberRow;


// WEBPACK FOOTER //
// ./components/Agile/member/memberList/memberRow/index.js